import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import {
    FONT_FAMILY_REGULAR,
    FONT_FAMILY_DEMI,
    DARK_NAVY_FONT_COLOR,
    SECONDARY_FONT_COLOR,
    CURSOR,
} from 'src/styles/fonts/MCFontConstants';

/**
 * ConsignedFilter - styled components (SCAFFOLD)
 * Filter icon + popup shell modeled on the Field Inventory Dashboard filter.
 */
export const FilterIconContainer = styled.div`
    position: relative;
    height: 1.875rem;
    width: 1.875rem;
    flex-shrink: 0;
`;

export const FilterIcon = styled.div`
    background: url(${(props) => props.deskPath});
    background-repeat: no-repeat;
    background-position: center;
    width: 100%;
    height: 100%;
    cursor: ${CURSOR};
    ${media.mobileDevice`
        background: url(${(props) => props.mobilePath});
        background-repeat: no-repeat;
        background-position: center;
    `}
`;

export const FilterPopup = styled.div.attrs({ 'data-filter-popup': '' })`
    position: absolute;
    top: calc(100% + 8px);
    right: -5px;
    z-index: 1000;
    background: #f5f5f5;
    box-shadow: 0px 0px 6px #00000029;
    width: 390px;
    max-width: 92vw;
    display: flex;
    flex-direction: column;
    border-radius: 6px;
    overflow: hidden;
    ${media.mediumDevice`
        width: 360px;
    `}
    ${media.mobileDevice`
        top: 0;
        right: -20px;
        width: 100vw;
        max-width: none;
        border-radius: 0;
    `}
`;

export const FilterHeader = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    background: #ffffff;
    padding: 14px 16px;
    border-bottom: 1px solid #e0e0e0;
`;

export const FilterHeading = styled.p`
    color: ${DARK_NAVY_FONT_COLOR};
    font-size: 20px;
    font-family: ${FONT_FAMILY_DEMI};
    margin: 0;
`;

export const FilterReset = styled.p`
    color: #1010eb;
    font-size: 14px;
    font-family: ${FONT_FAMILY_DEMI};
    margin: 0;
    cursor: ${CURSOR};
`;

export const FilterBody = styled.div`
    display: flex;
    flex-direction: column;
    background: #f5f5f5;
    min-height: 120px;
    max-height: 60vh;
    overflow-y: auto;
    padding: 16px;
`;

export const FilterEmptyState = styled.div`
    font-family: ${FONT_FAMILY_REGULAR};
    font-size: 13px;
    color: ${SECONDARY_FONT_COLOR};
    text-align: center;
    padding: 24px 12px;
`;

export const FilterFooter = styled.div`
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    gap: 12px;
    background: #ffffff;
    padding: 12px 16px;
    border-top: 1px solid #e0e0e0;
`;
